// extracted by mini-css-extract-plugin
export default {"container":"MainPageCharts_container__tkOX2","row":"MainPageCharts_row__BHvPx","title":"MainPageCharts_title__Pu4Gs"};